const initialState = {
    statusShow: false,
    id:'',
    textAddress:'',
    lng:0,
    lat:0,
};
const modalEditAddress = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_EDIT_ADDRESS':
            return {...state, statusShow: true,textAddress: action.address.address,
                lat: action.address.glat,
                lng: action.address.glng,
                id:action.address.addressId
            };
        case 'CLOSE_MODAL_EDIT_ADDRESS':
            return {...state, statusShow: false};
        case 'CHANGE_INPUTS_MODAL_EDIT_ADDRESS':
            return {...state, [action.name]:action.value};
        case 'CHANGE_LOCATION_MODAL_EDIT_ADDRESS':
            return {...state, lng:action.lng,lat:action.lat};
        case 'REFRESH_MODAL_EDIT_ADDRESS':
            return initialState;
        default:
            return state;
    }
};

export default modalEditAddress;
